import React from 'react';

const Download = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fillRule="evenodd" d="M31 30a1 1 0 110 2H1a1 1 0 110-2h30zM15.226.325a1.104 1.104 0 011.564 0c.217.216.326.484.326.799v20.938l9.488-10.774c.202-.231.46-.356.764-.37.29-.01.571.079.8.28.222.165.355.429.371.748.014.313-.081.587-.28.815L16.836 25.728a.461.461 0 01-.195.18l-.073.074-.128.042a1.8 1.8 0 01-.215.058 1.098 1.098 0 01-.435 0 1.852 1.852 0 01-.215-.058l-.2-.115a.456.456 0 01-.194-.18L3.759 12.762a1.751 1.751 0 01-.21-.348.965.965 0 01-.089-.39 1.06 1.06 0 01.402-.838.916.916 0 01.358-.221c.127-.043.272-.065.432-.065.179.03.305.07.421.123.14.062.258.155.351.279l9.476 10.76V1.124c0-.314.11-.583.326-.8z"></path></svg>
  )
}

export default Download
